<template>
	<div>
		<article
			v-for="item in promotion"
			:key="item.wp_id"
			class="promotion-article"
		>
			<div class="promotion-article__content u-container">
				<div class="prom-title-box">
					<h2 class="prom-title-box__title">{{ item.wp_subject }}</h2>
					<p class="prom-title-box__date">
						{{ item.wp_startdate }} ~ {{ item.wp_enddate }}
					</p>
				</div>

				<div class="prom-upload">
					<img :src="getPromotionUrl(item.wp_filename)" alt="" />
				</div>
			</div>

			<div class="promotion-article__help u-container">
				<p>※자세한 내용은 지점으로 문의 바랍니다.</p>
			</div>
		</article>

		<InfiniteLoading
			@infinite="infiniteHandler"
			spinner="circles"
			ref="infiniteLoading"
		>
			<div slot="no-more"></div>
			<div slot="no-results">조회 결과가 없습니다.</div>
		</InfiniteLoading>
	</div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading';

import { fetchPromotion } from '@/api';

const INCREMENT_COUNT = 2; // 조회 결과 증가 개수

export default {
	components: {
		InfiniteLoading,
	},
	data() {
		return {
			limit: INCREMENT_COUNT,
			promotion: [],
		};
	},
	methods: {
		getPromotionUrl(filename) {
			const S3_BASE_URL = process.env.VUE_APP_S3_BASE_URL;
			const basePath = '/himo-app/uploads/promotion/';

			const hasFullPath = filename.includes(basePath);
			const uploadPath = hasFullPath
				? `${S3_BASE_URL}${filename}`
				: `${S3_BASE_URL}${basePath}${filename}`;

			return uploadPath;
		},
		async renderPromotion(state) {
			const params = {
				rowCount: this.limit,
			};

			const { data } = await fetchPromotion(params);

			setTimeout(() => {
				if (data.code === '00000') {
					this.promotion = data.promotion;

					if (state) {
						this.setInfiniteState(data, state);
					}
				}
			}, 500);
		},
		infiniteHandler(state) {
			this.renderPromotion(state);
		},
		setInfiniteState(data, state) {
			const promotion = data.promotion;
			const totalCount = data.totalCount;

			if (promotion && promotion.length) {
				if (this.limit > totalCount) {
					state.complete();
				} else {
					state.loaded();
				}

				this.limit += INCREMENT_COUNT;
			} else {
				state.complete();
			}
		},
	},
};
</script>
